import React from 'react';
import { RouterProvider } from 'react-router-dom';

import setupTrackers from '@pukka/clevertap/setupTrackers';
import { setupClickstream } from '@pukka/clickstream';
import '@pukka/i18n';
import { getWorker } from '@pukka/msw';
import { queryClient } from '@pukka/tanstack-query';
import { getUnleashClient } from '@pukka/unleash';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FlagProvider } from '@unleash/proxy-client-react';
import ReactDOM from 'react-dom/client';

import './styles/index.css';

import router from './routes';

async function App() {
  await (await getWorker())?.start();
  await setupTrackers();
  await setupClickstream();

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <FlagProvider unleashClient={getUnleashClient()}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </FlagProvider>
    </React.StrictMode>,
  );
}

App();
